export default function ClassesAncestriesTab() {
  return (
    <>
      <h3 id="classes">CLASSES</h3>
      <p>All classes are available, but some have unique aspects within a Witherwild campaign. As needed, provide the following information to your players.</p>

      <div className="feature-block">
        <div className="feature-name">DRUIDS, RANGERS, AND SORCERERS</div>
        <div className="feature-text">Druids, rangers, and sorcerers are commonly found throughout Fanewick. If players choose one of these classes, they should consider how their character{"'"}s connection to the natural world might be impacted by the Witherwild.</div>
      </div>

      <div className="feature-block">
        <div className="feature-name">WARRIORS AND WIZARDS</div>
        <div className="feature-text">Warriors and wizards are prevalent in Haven. A large wizarding school in Haven teaches fighters and healers, and the Haven Army is largely composed of warriors and School of War wizards. If a PC is either of these classes, consider their personal relationship to the Haven Army.</div>
      </div>

      <div className="feature-block">
        <div className="feature-name">VENGEANCE GUARDIAN</div>
        <div className="feature-text">Many Wicklings who seek revenge on Haven or to expel them from Fanewick become Vengeance guardians. If players choose this subclass, they should consider what ideals or institutions their character protects.</div>
      </div>

      <div className="feature-block">
        <div className="feature-name">SYNDICATE ROGUE</div>
        <div className="feature-text">The Haven Army sends spies into Fanewick communities to gain information on planned attacks and manipulate public perception. When selecting the Syndicate rogue subclass, players should consider how their character might be connected to or impacted by these covert operations.</div>
      </div>

      <h3 id="ancestries">ANCESTRIES</h3>
      <p>All ancestries are available, but some have unique aspects within a Witherwild campaign. As needed, provide the following information to your players.</p>

      <div className="feature-block">
        <div className="feature-name">CLANKS</div>
        <div className="feature-text">Clanks from Haven are commonly made from iron and steel, while clanks from Fanewick are typically constructed from wood and stone.</div>
      </div>

      <div className="feature-block">
        <div className="feature-name">FUNGRIL</div>
        <div className="feature-text">Since the Witherwild spread throughout Fanewick, some fungril inhabiting the forests have grown noticeably larger than fungril from other regions.</div>
      </div>

      <div className="feature-block">
        <div className="feature-name">DRAKONA, FAUNS, FIRBOLGS, AND INFERNIS</div>
        <div className="feature-text">After the Witherwild corrupted Fanewick, some drakona, fauns, firbolgs, and infernis have noticed their horns growing faster and longer.</div>
      </div>

      <div className="feature-block">
        <div className="feature-name">GALAPA AND RIBBETS</div>
        <div className="feature-text">Many families of galapa and ribbets who lived in the bogs of Fanewick were displaced when Haven{"'"}s army invaded.</div>
      </div>

      <h3 id="serpents-sickness-note">HAVENITES AND THE SERPENT{"'"}S SICKNESS</h3>
      <div className="ww-blockquote ww-blockquote--amber">
        <p>Anyone, but especially those from Haven, may carry the Serpent{"'"}s Sickness, which stiffens their movements and gives them limited time to survive without a cure.</p>
      </div>
    </>
  );
}
